import { ArticleConditionForm } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { Weight } from '@/routes/Requests/Request/Article/Weight';

export const WeightInput = ({
  articleConditionForms,
}: {
  articleConditionForms: ArticleConditionForm[];
}) => {
  const { view } = useArticleContext();
  const editableArticleConditionForm = articleConditionForms?.find(
    (articleConditionForm) => !articleConditionForm.completedAt
  );

  const weightIsEditable = view.qualityControl.editable && !!editableArticleConditionForm;

  if (!weightIsEditable || !view.details.weight.shown) return null;

  return <Weight />;
};
